export default __webpack_public_path__ + "static/HeroVideoforDesktop-bf95589710485285e95fdc2d7f2665aa.mp4";